import { AsyncStorage } from "react-native";

let dataMemory = {};

/** @class */
class MemoryStorage {
	/**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */
	static setItem(key, value) {
		try {
			AsyncStorage.setItem(key, value);
		} catch (err) {
			console.log(`failed to get item with ${err}`);
		}

		dataMemory[key] = value;
		return dataMemory[key];
	}

	/**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */
	static getItem(key) {
		async () => {
			try {
				const value = await AsyncStorage.getItem(key);
				if (value !== null) {
					return value;
				} else {
					return undefined;
				}
			} catch (err) {
				console.log(`failed to get item with ${err}`);
			}
		};

		return Object.prototype.hasOwnProperty.call(dataMemory, key)
			? dataMemory[key]
			: undefined;
	}

	/**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */
	static removeItem(key) {
		AsyncStorage.removeItem(key);
		return delete dataMemory[key];
	}

	/**
   * This is used to clear the storage
   * @returns {string} nothing
   */
	static clear() {
		AsyncStorage.getAllKeys().then(AsyncStorage.mulitRemove);
		dataMemory = {};
		return dataMemory;
	}

	static setData(data) {
		dataMemory = data;
	}
}

export default MemoryStorage;



// WEBPACK FOOTER //
// ./src/utils/MemoryStorage.js